import type { CoreApiClient } from "../client";
import { createPlanningMutations } from "../mutations/planning.mutations";

export const createPlanningRepository = (api: CoreApiClient) => ({
  ...createPlanningMutations(api),
});
